// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.LeaseType

export enum LeaseType {
  COSMOS = 'COSMOS',
  SELF_UPLOAD = 'SELF_UPLOAD',
  SIGNED_SELF_UPLOAD = 'SIGNED_SELF_UPLOAD',
  ZILLOW = 'ZILLOW',
}

export const LeaseType_values = [
  LeaseType.COSMOS,
  LeaseType.SELF_UPLOAD,
  LeaseType.SIGNED_SELF_UPLOAD,
  LeaseType.ZILLOW,
] as const;
